import React, { useContext } from "react";
import {
    DraftPlaylist,
    PlaylistItem,
    Playlist,
    PlaylistStatus,
    MinimalPlaylistItem,
} from "../../../../type";
import { IntlShape, defineMessages, useIntl } from "react-intl";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import { getDefaultPlaylistTitle } from "../../../EditPlaylist/utils";
import { sessionStore } from "../../../../../../../contexts/SessionContext";
import { useHistory } from "react-router-dom";
import { useUrl } from "../../../../../../../hooks/usePage";
import { Pagetype } from "../../../../../../../interfaces/Config";
import { ROUTES, TITLE_MAX_LEN } from "../../../const";
import { useCreatePlaylistMutation } from "../../../../api/useMutations";
import { ResourcePath } from "../../../utils";

type Props = {
    playlistInPreview?: Playlist<PlaylistItem>;
    nbPlaylists?: number;
    className?: string;
};

const DuplicateButton = ({
    playlistInPreview,
    nbPlaylists,
    className,
}: Props) => {
    const intl = useIntl();
    const {
        session: { userId },
    } = useContext(sessionStore);
    const history = useHistory();
    const playlistURL = useUrl(Pagetype.WORKMODE_PLAYLIST);

    const { mutate: createPlaylist } = useCreatePlaylistMutation();
    const handleDuplicatePlaylist = () => {
        if (!playlistInPreview) return;
        const duplicatePlaylist: Omit<
            DraftPlaylist<ResourcePath | MinimalPlaylistItem>,
            "dirty"
        > = {
            name: getDuplicatedPlaylistTitle(
                intl,
                nbPlaylists,
                playlistInPreview.name
            ),
            description: "",
            status: { status: PlaylistStatus.DRAFT },
            author_id: userId,
            learning_items: playlistInPreview.learning_items,
        };
        createPlaylist(duplicatePlaylist, {
            onSuccess: (data) => {
                history.push(
                    `${playlistURL}/${ROUTES.edit}/${data.learning_set_id}`
                );
            },
        });
    }; // TODO handle error

    return (
        <Button
            className={className}
            label={intl.formatMessage(messages.playlistDuplicate)}
            icons={[{ path: "duplicate" }]}
            onClick={handleDuplicatePlaylist}
            disabled={!playlistInPreview}
        />
    );
};
export default DuplicateButton;

const getDuplicatedPlaylistTitle = (
    intl: IntlShape,
    playlistsLength: number | undefined,
    originalName: string
) => {
    let nextTitle = getDefaultPlaylistTitle(intl, playlistsLength ?? 1);
    return `${nextTitle} - ${intl.formatMessage(
        messages.playlistIsDuplicate
    )} ${originalName} `.slice(0, TITLE_MAX_LEN);
};

const messages = defineMessages({
    playlistDuplicate: {
        id: "playlist-duplicate",
        defaultMessage: "Duplicate.",
    },
    playlistIsDuplicate: {
        id: "playlist-is-duplicate",
        defaultMessage: "Duplicate of",
    },
});
